import styled from 'styled-components'

export const Container = styled.div`
	form > div {
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		gap: 4px;

		.select {
			width: 350px;
			margin: 8px 0 0;
		}

		button {
			margin: 0 8px;
		}

		@media(max-width: 650px) {
			flex-direction: column;
			align-items: unset;
			gap: 12px;

			.select {
				width: 100%;
			}

			button {
				align-self: flex-end;
			}
		}
	}
`
